import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import { app } from '../config/firebaseConfig';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet-async';
import emailjs from 'emailjs-com';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

const BlogDetail = () => {
  const { canonicalUrl } = useParams();
  const [blog, setBlog] = useState(null);
  const [latestPosts, setLatestPosts] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [date, setDate] = useState(new Date());

  console.log("canonicalUrl from URL:", canonicalUrl);

  useEffect(() => {
    const fetchBlog = async () => {
      const db = getFirestore(app);
      console.log("Fetching blog with canonicalUrl:", canonicalUrl);

      try {
        const blogsRef = collection(db, 'blogs');
        const q = query(blogsRef, where('canonicalUrl', '==', canonicalUrl));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          const data = doc.data();
          console.log("Blog data found:", data);
          setBlog({
            ...data,
            date: data.date ? data.date.toDate().toLocaleDateString() : '',
          });
        } else {
          console.error('Blog bulunamadı!');
          setError('Blog bulunamadı!');
        }
      } catch (error) {
        console.error('Veri çekme hatası: ', error.message);
        setError('Veri çekme hatası: ' + error.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchLatestPosts = async () => {
      const db = getFirestore(app);
      const latestPostsRef = collection(db, 'blogs');
      const latestPostsSnap = await getDocs(latestPostsRef);
      
      const posts = latestPostsSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      setLatestPosts(posts);
    };

    fetchBlog();
    fetchLatestPosts();
  }, [canonicalUrl]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;

    emailjs
      .sendForm(
        "hacialiweb",
        "template_vvyvpli",
        form,
        "bGhtkhENRI184jo1r"
      )
      .then(
        (result) => {
          setStatus('Mesajınız başarıyla gönderildi!');
          setFormData({ from_name: '', from_email: '', message: '' });
        },
        (error) => {
          setStatus('Mesaj gönderilirken bir hata oluştu.');
        }
      );
  };

  if (loading) {
    return <div className="text-center mt-5">Yükleniyor...</div>;
  }

  if (error) {
    return <div className="text-center mt-5">{error}</div>;
  }

  return (
    <div className="blog-single gray-bg">
      <Helmet>
        <title>{`${blog.title} - Blog`}</title>
        <meta name="description" content={blog.description || "Blog yazısının açıklaması."} />
        <meta property="og:title" content={blog.title} />
        <meta property="og:description" content={blog.description || "Blog yazısının açıklaması."} />
        <meta property="og:image" content={blog.image || "https://www.bootdey.com/image/800x350/87CEFA/000000"} />
        <meta property="og:url" content={`https://www.hacialikara.com/blog/${canonicalUrl}`} />
        <meta name="twitter:title" content={blog.title} />
        <meta name="twitter:description" content={blog.description || "Blog yazısının açıklaması."} />
        <meta name="twitter:image" content={blog.image || "https://www.bootdey.com/image/800x350/87CEFA/000000"} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="container">
        <div className="row align-items-start">
          <div className="col-lg-8 m-15px-tb">
            <article className="article">
              <div className="article-img">
                <img src={blog.image || "https://www.bootdey.com/image/800x350/87CEFA/000000"} alt={blog.title} />
              </div>
              <div className="article-title">
                <h6><span>{blog.category || "Eğitim"}</span></h6>
                <h2>{blog.title}</h2>
                <div className="media">
                  <div className="avatar">
                    <img src={blog.authorAvatar || "../resimler/profilavatar.png"} alt={blog.author} />
                  </div>
                  <div className="media-body">
                    <label>{blog.author || "Hacı Ali Kara"}</label>
                    <span>{blog.date}</span>
                  </div>
                </div>
              </div>
              <div className="article-content">
                <div dangerouslySetInnerHTML={{ __html: blog.description }} />
                <div dangerouslySetInnerHTML={{ __html: blog.content }} />
                <blockquote>
                  <p>{blog.quote || "Eğitim, bir insanın dünyayı değiştirebileceği en güçlü araçtır."}</p>
                  <p className="blockquote-footer">Nelson Mandela</p>
                </blockquote>
                <div dangerouslySetInnerHTML={{ __html: blog.additionalContent }} />
              </div>
              <div className="nav tag-cloud">
                {blog.tags?.map((tag, index) => (
                  <span key={index} className="tag">{tag}</span>
                ))}
              </div>
            </article>

            <div className="contact-form article-comment">
              <h4>İletişim Formu</h4>
              <form id="contact-form" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        name="from_name"
                        id="name"
                        placeholder="Adınız *"
                        className="form-control"
                        type="text"
                        value={formData.from_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        name="from_email"
                        id="email"
                        placeholder="E-posta Adresiniz *"
                        className="form-control"
                        type="email"
                        value={formData.from_email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        id="message"
                        placeholder="Mesajınız *"
                        rows="4"
                        className="form-control"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="send">
                      <button className="px-btn theme" type="submit">
                        <span>Gönder</span> <i className="arrow"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              {status && <div className="status-message">{status}</div>}
            </div>
          </div>

          <div className="col-lg-4 m-15px-tb blog-aside">
            <div className="widget widget-author">
              <div className="widget-title">
                <h3>Hakkımda</h3>
              </div>
              <div className="widget-body">
                <div className="media align-items-center">
                  <div className="avatar">
                    <img src={blog.authorAvatar || "../resimler/profilavatar.png"} alt={blog.author} />
                  </div>
                  <div className="media-body">
                    <h6>Merhaba, ben<br /> Hacı Ali Kara</h6>
                  </div>
                </div>
                <p>
                  Kocaeli Üniversitesi İngiliz Dili ve Edebiyatı Bölümü mezunuyum. 8 yılı aşkın süredir eğitim alanında çalışıyorum. 
                  Özel Kocaeli Güneş Okulları'nda İngilizce öğretmeni ve İngilizce Zümre Başkanı olarak görev yapmaktayım. 
                  Öğrencilerimin dil becerilerini geliştirmek ve onları global dünyaya hazırlamak benim için büyük bir tutku.
                </p>
              </div>
            </div>

            <div className="widget widget-latest-post">
              <div className="widget-title">
                <h3>Son Yazılar</h3>
              </div>
              <div className="widget-body">
                {latestPosts.slice(0, 5).map((post) => (
                  <div key={post.id} className="latest-post-aside media">
                    <div className="lpa-left media-body">
                      <div className="lpa-title">
                        <h5><a href={`/blog/${post.canonicalUrl}`}>{post.title}</a></h5>
                      </div>
                      <div className="lpa-meta">
                        <span className="name">{post.author || "Yazar"}</span>
                        <span className="date">{post.createdAt?.toDate().toLocaleDateString()}</span>
                      </div>
                    </div>
                    <div className="lpa-right">
                      <a href={`/blog/${post.id}`}>
                        <img src={post.image || "https://via.placeholder.com/80x80"} alt={post.title} />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="widget widget-calendar">
              <div className="widget-title">
                <h3>Takvim</h3>
              </div>
              <div className="widget-body">
                <Calendar
                  onChange={setDate}
                  value={date}
                  className="react-calendar-custom"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;